// 45-B, paczka PH — harmonogram: tryby, dni ciszy, naglowek wyniku, lista kont (C0, KONTRAKTY 2026-09-24).
// Poddrzewo `appCampaigns.h45.*`: ten plik edytuje TYLKO jego paczka; klucze PL i EN rownoczesnie.
// Teksty: MAPA 45-B „Teksty PL / EN”; zero zdan objasniajacych (regula 8) — dane, pigulki, male przyciski.
export const appCampaignsH45 = {
  h45: {
    result: {
      end: 'End',
      ofPool: 'Posts: {placed} of {pool}',
      ownEnd: 'the end is set by an account with its own schedule',
    },
    mode: {
      label: 'Schedule mode',
      range: 'Start and end',
      weekly: 'Weekly',
    },
    start: {
      today: 'today, {time}',
      tomorrow: 'tomorrow, {time}',
      at: '{date}, {time}',
      change: 'Change start: {when}',
      day: 'Start day',
      time: 'Start time',
    },
    end: {
      none: 'no end date',
      date: 'date',
      dateLabel: 'End date',
      earlier: 'Earlier',
      later: 'Later',
      weeks_one: '{n} wk',
      weeks_few: '{n} wk',
      weeks_many: '{n} wk',
    },
    duration: 'Duration',
    perDay: {
      label: 'Per account per day',
      from: 'from',
      to: 'to',
      min: 'Per account per day, from',
      max: 'Per account per day, up to',
    },
    advanced: {
      label: 'Advanced',
      hours: 'Hours',
      hoursFrom: 'Hours from',
      hoursTo: 'Hours to',
      gap: 'Gap',
      gapValue: 'every {n} h',
      quiet: 'Quiet days',
      work: 'Work',
      workMin: 'Work from',
      workMax: 'Work up to',
      quietLen: 'Quiet',
      days_one: 'day',
      days_few: 'days',
      days_many: 'days',
      quietIn: 'Quiet in plan',
      quietOff: 'no quiet days',
      quietOn_one: 'quiet every {min}-{max} day',
      quietOn_few: 'quiet every {min}-{max} days',
      quietOn_many: 'quiet every {min}-{max} days',
      quietCell: 'quiet day',
    },
    week: {
      label: 'Week of the plan',
    },
    accounts: {
      title: 'Accounts',
      pace: '{min}-{max} a day',
      paceOne: '{n} a day',
      perWeek: '{n} / wk',
      until: 'until {date}',
      count: 'Account posts: {placed} of {assigned}',
      lifted: 'limits lifted',
      own: 'own schedule',
    },
    why: {
      limit: 'limit {n} a day',
      gap: 'gap {n} h',
      window: 'hours {from}-{to}',
      own: 'own schedule',
    },
    fix: {
      limit: 'Change limit',
      gap: 'Change gap',
      window: 'Change hours',
      extend: 'Extend to {date}',
      lift: 'Lift limits',
      liftLabel: 'Lift the limits of {name} for this plan',
      restore: 'Restore limits',
      restoreLabel: 'Restore the limits of {name} for this plan',
    },
    dryRun: {
      error: 'Couldn’t calculate the plan.',
      retry: 'Retry',
    },
    fault: {
      gap: 'gap too short',
      start: 'start too early',
      slot: 'time {time}',
      week: 'too many times a day',
      window: 'end before start',
    },
    value: {
      range: 'from {start} · {min}-{max} a day · no end date',
      rangeOne: 'from {start} · {n} a day · no end date',
      rangeEnd: 'from {start} to {end}',
      weekly: 'Weekly · {n} / wk · {duration}',
    },
    partial_one: 'Scheduled {n} · {left} left in the library',
    partial_few: 'Scheduled {n} · {left} left in the library',
    partial_many: 'Scheduled {n} · {left} left in the library',
    changed: 'plan recalculated',
  },
}
